import React from 'react';

import SharePromptButton from '@/features/ai-chat/components/AskGXDrawer/SharePromptButton/SharePromptButton';
import TextType from '@/features/ai-chat/components/AskGXDrawer/TextType/TextType';
import type { HumanMessage as HumanMessageType } from '@/features/ai-chat/types/chat.types';
import { Box } from '@/shared/ui/layout/Box';
import Typography from '@/shared/ui/typography/Text';

import { useHumanMessage } from './useHumanMessage';

const HumanMessage = ({ msg }: { msg: HumanMessageType }) => {
  const { promptShareEnabled, animatedText, onAnimatedComplete, shouldAnimate } =
    useHumanMessage(msg);

  return (
    <Box
      sx={{
        alignSelf: 'flex-end',
        maxWidth: '70%'
      }}
    >
      <Box
        sx={{
          padding: '12px',
          marginBottom: '12px',
          minWidth: '208px',
          backgroundColor: 'gx.actionBarButtonTile',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}
      >
        <Typography
          component='div'
          sx={{ overflowWrap: 'break-word', hyphens: 'auto', fontSize: '14px' }}
        >
          <Box sx={{ fontWeight: 700 }}>You:</Box>
          <Box>
            {shouldAnimate ? (
              <TextType
                showCursor
                as='div'
                loop={false}
                text={animatedText as string}
                onComplete={onAnimatedComplete}
              />
            ) : (
              msg.text
            )}
          </Box>
        </Typography>
        {promptShareEnabled && <SharePromptButton prompt={msg.text} />}
      </Box>
    </Box>
  );
};

export default HumanMessage;
